(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  class VideoGalleryItem extends HTMLElement {
    constructor() {
      super();
      this.playButton = this.querySelector('.video-gallery-item__play-button');
      this.pauseButton = this.querySelector('.video-gallery-item__pause-button');
      this.video = this.querySelector('video');
      this.iframe = this.querySelector('iframe');
      this.isPlaying = false;
      
      if (this.playButton) {
        this.playButton.addEventListener('click', () => this.playVideo());
      }
      
      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', () => this.pauseVideo());
      }

      // Pause video when it ends
      if (this.video) {
        this.video.addEventListener('ended', () => this.resetVideo());
        this.video.addEventListener('pause', () => this.showPlayButton());
        this.video.addEventListener('play', () => this.showPauseButton());
      }
    }

    playVideo() {
      if (this.video) {
        // Enable sound for video playback
        this.video.muted = false;
        this.video.play().then(() => {
          this.isPlaying = true;
          this.showPauseButton();
        }).catch(error => {
          console.log('Video play failed:', error);
        });
      } else if (this.iframe) {
        // For YouTube/Vimeo videos, enable autoplay and sound
        const src = this.iframe.src;
        if (src.includes('youtube.com')) {
          this.iframe.src = src.replace('autoplay=0', 'autoplay=1').replace('mute=1', 'mute=0');
        } else if (src.includes('vimeo.com')) {
          this.iframe.src = src.replace('autoplay=0', 'autoplay=1').replace('muted=1', 'muted=0');
        }
        this.isPlaying = true;
        this.showPauseButton();
      }
    }

    pauseVideo() {
      if (this.video && this.isPlaying) {
        this.video.pause();
        this.isPlaying = false;
        this.showPlayButton();
      } else if (this.iframe) {
        this.iframe.src = this.iframe.src.replace('autoplay=1', 'autoplay=0').replace('mute=0', 'mute=1');
        this.isPlaying = false;
        this.showPlayButton();
      }
    }

    showPlayButton() {
      if (this.playButton) this.playButton.style.display = 'flex';
      if (this.pauseButton) this.pauseButton.style.display = 'none';
    }

    showPauseButton() {
      if (this.playButton) this.playButton.style.display = 'none';
      if (this.pauseButton) this.pauseButton.style.display = 'flex';
    }

    resetVideo() {
      this.isPlaying = false;
      this.showPlayButton();
      
      if (this.video) {
        this.video.currentTime = 0;
        this.video.muted = true;
      }
    }

  }

  if (typeof customElements.get('video-gallery-item') === 'undefined') {
    customElements.define('video-gallery-item', VideoGalleryItem);
  }

  // Pause all videos when scrolling away from the section
  document.addEventListener('DOMContentLoaded', function() {
    const videoGalleryItems = document.querySelectorAll('video-gallery-item');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          const videoItem = entry.target.querySelector('video-gallery-item');
          if (videoItem && videoItem.pauseVideo) {
            videoItem.pauseVideo();
          }
        }
      });
    }, {
      threshold: 0.5
    });

    videoGalleryItems.forEach(item => {
      observer.observe(item);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
